/**
 * Created by Oles on 4/28/2017.
 */
import React, { Component  } from 'react';
import { connect } from 'react-redux';
import * as actions from '../actions/index';
import {MessageBoxTypes} from "../const/TestResultsConst";
import  {TestResultRow}  from '../components/TestResultRow.jsx';

const mapStateToProps = (state, ownProps) => {
    var positiveGenes = ownProps.row.genes.filter(gene => gene.classification && gene.classification.length > 0 && gene.classification.toUpperCase() !== 'Negative'.toUpperCase());
    var results = positiveGenes.map(gene => { return gene.classification + ' ' + gene.gene }).join(', ');

    var props = {
        id: ownProps.row.id,
        submittedDate: ownProps.row.submittedDate,
        reportedDate: ownProps.row.reportedDate,
        reclassDate: ownProps.row.reclassDate,
        lab: ownProps.row.lab,
        testOrdered: ownProps.row.testOrdered,
        testStatus: ownProps.row.testStatus,
        documents: ownProps.row.documents,
        result: results,
        notes: ownProps.row.notes,
        columns: state.testColumns
    };
    return props;
};

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        showTestDetails: (id) => dispatch(actions.showTestDetails(true, id)),
        onTestDelete: () => dispatch(actions.showMessageBox(true, MessageBoxTypes.DELETE_TEST)),
        setCurrent: id => dispatch(actions.setCurrentTestId(id)),
        onViewDetails: id => dispatch(actions.showTestDetails(true, id)),
        onDocSelected: id => dispatch(actions.openDocument(id)),
        openDocumentByUrl: id => dispatch(actions.openDocumentByUrl(id))
    };
};

const TestResultRowController = connect(
    mapStateToProps,
    mapDispatchToProps
)(TestResultRow);

export default TestResultRowController;